<div class="_relative _bg-grayscale-white _mb-6 xs:_mb-8 md:_mb-10 _rounded-lg"
     [class._cursor-pointer]="!isComingSoon()"
     (click)="openInNewTab()"
     *ngIf="searchListing">
        <app-property-listing-card 
          [consumerView]="consumerView"
          [searchListing]="searchListing">
        </app-property-listing-card>
</div>
